/* eslint-ignore */
// @ts-nocheck
import React, { useState } from 'react';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';

import Modelo1 from '../../../../../assets/images/modelo_1.svg';
import Modelo2 from '../../../../../assets/images/modelo_2.svg';
import Modelo3 from '../../../../../assets/images/modelo_3.svg';

import {
  Container,
  TextDetailModel,
  TextDetailModelHighlight,
  ModelImgContainer,
  ModelImg,
  WrapButtons,
  BackButton,
  NextButton,
} from './styles';
import ModalCodeExample from '../ModalCodeExample';

function ModalContent({ isOpen, setShowModal }) {
  const [activeModal, setActiveModal] = useState(1);

  return (
    <ModalCodeExample isOpen={isOpen} setShowModal={setShowModal}>
      <Container>
        {activeModal === 1 && (
          <>
            <TextDetailModel>
              <TextDetailModelHighlight>Modelo 1 -</TextDetailModelHighlight>{' '}
              Você pode encontrá-lo na seção{' '}
              <TextDetailModelHighlight>
                Dados adicionais
              </TextDetailModelHighlight>{' '}
              de sua nota fiscal no item{' '}
              <TextDetailModelHighlight>Correntista</TextDetailModelHighlight>,
              , como é exemplificado no exemplo abaixo:
            </TextDetailModel>
            <ModelImgContainer>
              <ModelImg src={Modelo1} alt="Modelo 1 nota fiscal" />
            </ModelImgContainer>
          </>
        )}
        {activeModal === 2 && (
          <>
            <TextDetailModel>
              <TextDetailModelHighlight>Modelo 2 -</TextDetailModelHighlight>{' '}
              Você pode encontrá-lo na seção{' '}
              <TextDetailModelHighlight>
                Dados adicionais
              </TextDetailModelHighlight>{' '}
              de sua nota fiscal no item{' '}
              <TextDetailModelHighlight>Cod.Cliente</TextDetailModelHighlight>,
              , como é exemplificado no exemplo abaixo:
            </TextDetailModel>
            <ModelImgContainer>
              <ModelImg src={Modelo2} alt="Modelo 2 nota fiscal" />
            </ModelImgContainer>
          </>
        )}
        {activeModal === 3 && (
          <>
            <TextDetailModel>
              <TextDetailModelHighlight>Modelo 3 -</TextDetailModelHighlight>{' '}
              Você pode encontrá-lo na seção{' '}
              <TextDetailModelHighlight>
                Dados adicionais
              </TextDetailModelHighlight>{' '}
              de sua nota fiscal no item{' '}
              <TextDetailModelHighlight>Cod.Cliente</TextDetailModelHighlight>,
              , como é exemplificado no exemplo abaixo:
            </TextDetailModel>
            <ModelImgContainer>
              <ModelImg src={Modelo3} alt="Modelo 3 nota fiscal" />
            </ModelImgContainer>
          </>
        )}
        <WrapButtons>
          <BackButton
            disabledButton={activeModal === 1}
            onClick={() => {
              if (activeModal === 1) return;
              setActiveModal(activeModal - 1);
            }}
          >
            <AiOutlineArrowLeft size={22} />
            Anterior
          </BackButton>
          <NextButton
            disabledButton={activeModal === 3}
            onClick={() => {
              if (activeModal === 3) return;
              setActiveModal(activeModal + 1);
            }}
          >
            Próximo
            <AiOutlineArrowRight size={22} />
          </NextButton>
        </WrapButtons>
      </Container>
    </ModalCodeExample>
  );
}

export default ModalContent;
